/**
 * The streamsaver endpoint for the Privacy Center
 */
export const PRIVACY_CENTER_STREAMSAVER_ENDPOINT =
  'https://streaming.transcend.io/endpoint.html';

/**
 * The streamsaver endpoint for the Admin Dashboard
 */
export const ADMIN_DASHBOARD_STREAMSAVER_ENDPOINT =
  '/penumbra/streamsaver/endpoint.html';
